import { render, staticRenderFns } from "./AccessoryMenu.vue?vue&type=template&id=8dd4b28a&scoped=true"
import script from "./AccessoryMenu.vue?vue&type=script&lang=ts"
export * from "./AccessoryMenu.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dd4b28a",
  null
  
)

export default component.exports